import React from "react";
import "./Indicator.scss"; // 스타일 파일

const Indicator = () => (
    <div className="indicator">
        <div className="spinner"></div>
    </div>
);

export default Indicator;
